import PropTypes from "prop-types";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";
import { replaceJSX } from "../../utilities/utilities";
import CancellationForm from "../cancellation-form";
import styles from "./styles";
import { useEffect, useRef, useState } from "react";
import SuccessView from "./success-view";
import { Alert } from "@asosteam/chameleon-alert/component";
import "@asosteam/chameleon-alert/styles.css";

const PremierCancellationLayout = ({ faqlink }) => {
  const errorRef = useRef();
  const translate = useTranslate(useLocaleProvider());
  const [formStatus, setFormStatus] = useState();

  useEffect(() => {
    if (formStatus === "error") {
      errorRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    } else if (formStatus === "success") {
      window.scrollTo(0, 0);
    }
  }, [formStatus]);

  return (
    <div className={styles.container} dir="ltr">
      {formStatus === "success" ? (
        <SuccessView />
      ) : (
        <>
          <div className={styles.card}>
            <h1 className="app_barnsley2">
              {translate("premier_cancel_contracts_form_title")}
            </h1>
          </div>
          <div className={styles.card}>
            <p className="app_leavesden2">
              {translate("premier_cancel_contracts_form_main_description")}
            </p>
            <p className="app_leavesden2">
              {translate("premier_cancel_contracts_form_description_detail")}
            </p>

            <p className="app_leavesden2">
              {replaceJSX(
                translate(
                  "premier_cancel_contracts_form_description_cancellation"
                ),
                "%{faqlink}",
                <a
                  key="faq-link"
                  className={styles.faqlink}
                  href={faqlink}
                  target="_blank"
                  rel="noreferrer"
                >
                  {translate(
                    "premier_cancel_contracts_form_description_cancellation_linktext"
                  )}
                </a>
              )}
            </p>
          </div>
          {formStatus === "error" && (
            <Alert
              ref={errorRef}
              className={styles.errorResponse}
              type="error"
              title={translate(
                "premier_cancel_contracts_form_error_message_title"
              )}
              message={translate(
                "premier_cancel_contracts_form_error_message_description"
              )}
            />
          )}
          <div className={styles.card}>
            <CancellationForm setFormStatus={setFormStatus} />
          </div>
        </>
      )}
    </div>
  );
};

PremierCancellationLayout.propTypes = {
  faqlink: PropTypes.string,
};

PremierCancellationLayout.defaultProps = {
  faqlink: "",
};

export default PremierCancellationLayout;
